import numbro from 'numbro';

import {TradeActionModal} from '../../components/modals/tradeSummary/tradeAction.modal';
import {Permissions} from '../../resources/tradeSummary.resource';

export const tradeSummaryFloorTradeColumnDefs = [
    {
        headerName: 'Original Trade Date',
        field: 'origTdate',
        type: 'date'
    },
    {
        cellRendererParams: {
            Body: TradeActionModal,
            name: 'tradeSummaryModal',
            parentTitle: 'Trade Summary',
            title: 'Trade Action',
            fullScreen: true
        },
        cellStyle: ({data}) => ({...(!data?.allowedTradeActions || data?.allowedTradeActions?.length === 0 || data?.evtTyp === 'RALC') && {display: 'none'}}),
        field: '_details_',
        permissions: [
            Permissions.adjustTradeSummary,
            Permissions.splitTradeSummary
        ],
        pinned: 'left',
        type: 'modal',
        sortable: false
    },
    {
        headerName: 'Event Type',
        field: 'evtTyp'
    },
    {
        headerName: 'Ref Exec Time',
        field: 'refExecTs',
        type: 'dateTime'
    },
    {
        headerName: 'Event Time',
        field: 'evtTs',
        type: 'dateTime'
    },
    {
        headerName: 'Common',
        headerClass: 'text-center',
        children: [
            {
                headerName: 'Deal Id',
                field: 'dealNum',
                type: 'numericString'
            },
            {
                headerName: 'Original Deal Id',
                field: 'dealIdOrig',
                type: 'numericString'
            },
            {
                headerName: 'Ref Deal Id',
                field: 'dealIdRef',
                type: 'numericString'
            },
            {
                field: 'symb',
                headerName: 'OSI Symbol'
            },
            {
                field: 'osiRootSymb',
                headerName: 'OSI Root Symbol'
            },
            {
                field: 'expirationDate',
                headerName: 'Expiration Date',
                type: 'date'
            },
            {
                field: 'putCall',
                headerName: 'Put/Call'
            },
            {
                field: 'strikePrice',
                headerName: 'Strike Price',
                type: 'price',
                cellRenderer: ({data}) =>
                    data.strikePrice === undefined
                        ? ''
                        : numbro(data.strikePrice).format({
                              mantissa: 8,
                              thousandSeparated: true
                          })
            },
            {
                field: 'execPrc',
                headerName: 'Price',
                type: 'price',
                cellRenderer: ({data}) =>
                    data.execPrc === undefined
                        ? ''
                        : numbro(data.execPrc).format({
                              mantissa: 8,
                              thousandSeparated: true
                          })
            },
            {
                field: 'execQty',
                headerName: 'Qty',
                type: 'number'
            },
            {
                field: 'tradeSequenceNumber',
                headerName: 'OCC Seq #'
            },
            {
                field: 'underlyingSymbol',
                headerName: 'Underlying Symbol'
            }
        ],
        marryChildren: true
    },
    {
        headerName: 'Customer Side',
        headerClass: 'success text-center',
        children: [
            {
                field: 'custClOrdId',
                headerName: 'Client Order Id'
            },
            {
                field: 'custFirmId',
                headerName: 'MPID'
            },
            {
                field: 'custIdPub',
                headerName: 'Public Order Id'
            },
            {
                field: 'custLqdtyInd',
                headerName: 'Liq Ind'
            },
            {
                field: 'custSessionId',
                headerName: 'Session Id'
            },
            {
                field: 'custSide',
                headerName: 'Side'
            },
            {
                field: 'custSndrSubId',
                headerName: 'MMID'
            },
            {
                field: 'custSubmittingBkrId',
                headerName: 'Badge'
            },
            {
                field: 'custClearingNumber',
                headerName: 'Clearing #'
            },
            {
                field: 'custOpenCloseDisplay',
                headerName: 'Open/Close'
            },
            {
                field: 'custFirmDisplay',
                headerName: 'Customer or Firm'
            },
            {
                field: 'custCmta',
                headerName: 'CMTA'
            },
            {
                field: 'custAccount',
                headerName: 'Account'
            },
            {
                field: 'custTif',
                headerName: 'Time In Force'
            },
            {
                field: 'custCrossId',
                headerName: 'Cross Id'
            },
            {
                field: 'custCapStrategyId',
                headerName: 'Cap Strategy'
            },
            {
                field: 'custOptnlData',
                headerName: 'Optional Data'
            }
        ],
        marryChildren: true
    },
    {
        headerName: 'Contra Side',
        headerClass: 'danger text-center',
        children: [
            {
                field: 'contraOrdFirmId',
                headerName: 'MPID'
            },
            {
                field: 'contraOrdSndrSubId',
                headerName: 'MMID'
            },
            {
                field: 'contraOrdSubmittingBkrId',
                headerName: 'Badge'
            },
            {
                field: 'contraOrdClearingNumber',
                headerName: 'Clearing #'
            },
            {
                field: 'contraOrdCrossId',
                headerName: 'Cross Id'
            },
            {
                field: 'contraOrdCapStrategyId',
                headerName: 'Cap Strategy'
            }
        ],
        marryChildren: true
    }
];
